module.exports = __webpack_public_path__ + "vue_assets/img/img_setting_solar_systems_and_galaxies.8ed634ae.png";